import styles from './CreditCardForm.module.scss';
import CreditCardElement from 'components/CreditCardElement/CreditCardElement';

const CreditCardForm = () => {
  return (
    <section className={styles.container}>
      <CreditCardElement />
    </section>
  );
};

export default CreditCardForm;
